import {forwardRef} from 'react';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function PositionedSnackbarAlert({ vertical = 'top', horizontal = 'center', open = false, message = '', severity='success' }) {
    return (
        <Box sx={{ width: 500 }}>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                key={vertical + horizontal}
            >
                <Alert severity={severity}>{message}</Alert>
            </Snackbar>
        </Box>
    );

}